import React, { CSSProperties } from "react";
import { FiMoreHorizontal } from "react-icons/fi";
import { getThemeColors, getComponentColors, Theme } from "../../theme/colors";

type Chat = {
  id: string;
  question: string;
  display_name: string;
};

interface ChatItemProps {
  chat: Chat;
  isRenaming: boolean;
  newDisplayName: string;
  setNewDisplayName: (name: string) => void;
  handleRenameSubmit: (e: React.FormEvent) => void;
  handleRenameCancel: () => void;
  onChatCreate: (id: string, shared: boolean) => void;
  handleOptionsClick: (
    e: React.MouseEvent,
    chatId: string,
    isShared: boolean
  ) => void;
  noOptions: boolean;
  passedInShared: boolean;
  username: string;
  colorMode: string;
}

export const ChatItem: React.FC<ChatItemProps> = ({
  chat,
  isRenaming,
  newDisplayName,
  setNewDisplayName,
  handleRenameSubmit,
  handleRenameCancel,
  onChatCreate,
  handleOptionsClick,
  noOptions,
  passedInShared,
  username,
  colorMode,
}) => {
  const currentColors = getThemeColors(username, colorMode as Theme);
  const sidebarColors = getComponentColors("sidebar", colorMode as Theme);

  const buttonStyle: CSSProperties = {
    borderWidth: "1px",
    borderColor: currentColors.border,
    borderRadius: "4px",
    padding: "0.5rem",
    justifyContent: "flex-start",
    transition: "all ease 0.5s",
    backgroundColor: "transparent",
    cursor: "pointer",
    color: currentColors.text,
    overflow: "hidden",
    whiteSpace: "nowrap",
  };

  const buttonHoverStyle: CSSProperties = {
    backgroundColor: sidebarColors.buttonHover || currentColors.buttonHover,
  };

  return (
    <div
      style={{
        ...buttonStyle,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
      onClick={() => onChatCreate(chat.id, passedInShared)}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor =
          buttonHoverStyle.backgroundColor || "";
      }}
      onMouseLeave={(e) =>
        (e.currentTarget.style.backgroundColor = "transparent")
      }
    >
      {isRenaming ? (
        <form onSubmit={handleRenameSubmit}>
          <input
            type="text"
            value={newDisplayName}
            onChange={(e) => setNewDisplayName(e.target.value)}
            onBlur={handleRenameCancel} // Cancel if focus is lost
            style={{
              width: "100%",
              flexGrow: 1,
              backgroundColor: currentColors.background,
              color: currentColors.text,
              border: `1px solid ${currentColors.border}`,
              borderRadius: "4px",
              padding: "0.5rem",
            }}
            autoFocus
          />
        </form>
      ) : (
        <span
          style={{
            flexGrow: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {chat.display_name && chat.display_name.length > 0
            ? chat.display_name
            : chat.question}
        </span>
      )}
      {!isRenaming && !noOptions && (
        <div
          onClick={(e) => handleOptionsClick(e, chat.id, passedInShared)}
          style={{ cursor: "pointer", flexShrink: 0 }}
        >
          <FiMoreHorizontal />
        </div>
      )}
    </div>
  );
};
